import { render, staticRenderFns } from "./InWork.vue?vue&type=template&id=817d431c"
import script from "./InWork.vue?vue&type=script&lang=js"
export * from "./InWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports